// Match the plugins shipped with the panel's self-hosted TinyMCE 6 bundle.
export const editorPlugins = "preview importcss searchreplace autolink autosave save directionality code visualblocks visualchars fullscreen image link media template codesample table charmap pagebreak nonbreaking anchor insertdatetime advlist lists wordcount help quickbars emoticons";
export const editorToolbar = "undo redo | bold italic underline strikethrough | fontfamily fontsize blocks | alignleft aligncenter alignright alignjustify | outdent indent | numlist bullist | forecolor backcolor removeformat | hr pagebreak | charmap emoticons | fullscreen preview print | image media template link anchor codesample | ltr rtl";

export function setupEditor(editor) {
  editor.ui.registry.addButton("print", {
    icon: "print", tooltip: "Print", onAction: () => editor.getWin().print(),
  });
}
